import { render, staticRenderFns } from "./AmeliaLogin.vue?vue&type=template&id=55cce91e"
import script from "./AmeliaLogin.vue?vue&type=script&lang=js"
export * from "./AmeliaLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports